/*  iceberg-ui  */
import { Box } from '@auviknetworks/iceberg-ui';

/* MUI */
import { useTheme } from '@mui/material/styles';

/*  Shared  */
import { Helpers } from 'application/Shared/Helpers';

/*  React  */
import React from 'react';

/**
 * Renders a styled text icon
 *
 * @param {Object} props - Component props
 * @param {string} [props.className] - CSS class name to apply to the icon container
 * @param {string} [props.classNameForNoImageInside] - CSS class name to apply to the inner text
 * @param {string} [props.classNameForNoImageOutside] - CSS class name to apply to the outer container
 * @param {Object} [props.sx] - CSS to apply custom styles
 * @returns {React.ReactElement} Rendered icon component
 */
export const RenderNoImage = ({
    className,
    classNameForNoImageInside,
    classNameForNoImageOutside,
    name,
    sx
}: {
    className?: string;
    classNameForNoImageInside?: string;
    classNameForNoImageOutside?: string;
    name?: string;
    sx?: React.CSSProperties;
}): React.ReactElement => {
    const { palette } = useTheme();

    let color1 = '';
    let color2 = '';
    let color3 = '';
    const itemName = name?.substring(0, 5) || 'aaaaaa';
    const baseColorScore = 40;
    color1 = Helpers.stringToColor(itemName, baseColorScore, baseColorScore);
    color2 = Helpers.stringToColor(
        itemName,
        baseColorScore + 3,
        baseColorScore + 3
    );
    color3 = Helpers.stringToColor(
        itemName,
        baseColorScore + 7,
        baseColorScore + 7
    );

    return (
        <Box
            className={`${className} ${classNameForNoImageOutside}`}
            sx={{
                background: `linear-gradient(45deg, ${color1} 0%, ${color2} 50%, ${color3} 100%)`,
                border: `1px solid ${color1}`,
                borderRadius: '3px',
                color: palette.text.white,
                display: 'block',
                fontSize: '9px',
                fontWeight: 600,
                height: '16px',
                paddingTop: 0,
                textAlign: 'center',
                width: '16px',
                ...sx
            }}
        >
            <Box
                aria-label={name}
                sx={{
                    ...(classNameForNoImageInside?.includes('bigIconText')
                        ? { fontSize: '18px' }
                        : {})
                }}
            >
                {name ? name.substring(0, 2).toUpperCase() : '?'}
            </Box>
        </Box>
    );
};
